import Vue from 'vue';

// window._ = require('lodash');
// window.Vue = require('vue');
// window.pluralize = require('pluralize')

// const retina = require('retinajs')
// const VueRetina = require('vue-retina')

// Vue.use(VueRetina, {retina})


if (document.querySelector('#post-comments-vue')) {
    new Vue({
        name: 'Journal Post Comments',
        el: '#post-comments-vue',
    });
}
